import {Component, Input, OnInit} from '@angular/core';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {
  PrepaidSharingPricePlanModel
} from '../../prepaid-sharing-price-plan/prepaid-sharing-price-plan-list/models/prepaid-sharing-price-plan.model';

@Component({
  selector: 'app-unit-prepaid-sharing-price-plans',
  templateUrl: './unit-prepaid-sharing-price-plans.component.html',
})
export class UnitPrepaidSharingPricePlansComponent implements OnInit {
  @Input() prepaidSharingPricePlans: PrepaidSharingPricePlanModel[];

  swiperConfig: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
  };

  ngOnInit() {
  }


}
